import { SearchMdIcon, XIcon } from '@systemeio/icons'
import { forwardRef, type KeyboardEvent } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { FormInputGroup, type FormInputGroupProps } from './form-input'

interface FormInputSearchProps extends Omit<FormInputGroupProps, 'trailingAction'> {
  onClear: () => void
}

const searchIcon = <SearchMdIcon aria-hidden="true" className="text-icon-secondary size-4" />

const FormInputSearch = forwardRef<HTMLInputElement, FormInputSearchProps>(
  (
    { leadingIcon = searchIcon, onClear, onKeyDown, placeholder, type, value, ...inputProps },
    ref,
  ) => {
    const { t } = useLocoTranslation()
    const isEmpty = value === '' || value === undefined || value === null

    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
      if (type === 'number' && ['e', 'E', '+', '-'].includes(event.key)) event.preventDefault()
      onKeyDown?.(event)
    }

    return (
      <FormInputGroup
        {...inputProps}
        ref={ref}
        leadingIcon={leadingIcon}
        onKeyDown={handleKeyDown}
        placeholder={placeholder ?? t('global.search')}
        spellCheck={false}
        trailingAction={
          !isEmpty ? (
            <button
              aria-label={t('global.clear')}
              className="text-icon-secondary hover:text-icon-primary focus-visible:focus-ring-primary transition-base flex size-6 items-center justify-center rounded-sm"
              onClick={onClear}
              type="button"
            >
              <XIcon aria-hidden="true" className="size-4" />
            </button>
          ) : undefined
        }
        type={type ?? 'text'}
        value={value}
      />
    )
  },
)

FormInputSearch.displayName = 'FormInputSearch'

export { FormInputSearch }
export type { FormInputSearchProps }
